import { render, staticRenderFns } from "./ResourceEdit.vue?vue&type=template&id=5391df8f&scoped=true&"
import script from "./ResourceEdit.vue?vue&type=script&lang=js&"
export * from "./ResourceEdit.vue?vue&type=script&lang=js&"
import style0 from "./ResourceEdit.vue?vue&type=style&index=0&id=5391df8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5391df8f",
  null
  
)

export default component.exports